import services from "@/services";

const state = {
	items: [],
	data: {},
	successInput: false,
};

const getters = {
	bannerDetail: (state) => state.data,
	bannerItems: (state) => {
		let groupItems = state.items?.map((x) => {
			x.actions = {
				id: x.id,
				url: `banners/edit/${x.id}`,
				name: x.banner_name,
				edit: "enable",
				delete: "enable",
			};
			return x;
		});
		return groupItems;
	},
};

const mutations = {
	setbanneritems: (state, items) => {
		state.items = items;
	},
	setbannerDetail: (state, data) => {
		state.data = data;
	},
	setStatusSubmit: (state, status) => {
		state.successInput = status;
	},
};

const actions = {
	getAll({ commit, dispatch }, param) {
		services.setHeader();
		dispatch("setLoadingTable", true, { root: true })
		return new Promise((resolve, reject) => {
			services
				.get("banner", param)
				.then((response) => {
					commit("setbanneritems", response.data.data.items);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				}).finally(() => {
					dispatch("setLoadingTable", false, { root: true })
				})
		});
	},
	getOneBanner({ commit, dispatch }, id) {
		services.setHeader();
		dispatch('setLoadingGlobal', true, { root: true })
		return new Promise((resolve, reject) => {
			services
				.get("banner/" + id)
				.then((response) => {
					commit("setbannerDetail", response.data.data);
					resolve(response.data.data);
				})
				.catch((error) => {
					reject(error);
				}).finally(() => {
					dispatch('setLoadingGlobal', false, { root: true })
				})
		});
	},
	delete({ commit, dispatch }, bannerId) {
		services.setHeader();
		let body = {
			id:bannerId
		}
		dispatch("setLoadingGlobal", true, { root: true })
		return new Promise((resolve, reject) => {
			services
				.delete(`banner/${bannerId}`, { data: body})
				.then((response) => {
					commit("setbanneritems", response.data.data.items);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				}).finally(() => {
					dispatch("setLoadingGlobal", false, { root: true })
				})
		});
	},
	createBanner({ commit, dispatch }, body) {
		services.setHeader();
		dispatch('setLoadingGlobal', true, { root: true })
		return new Promise((resolve, reject) => {
			services
				.post("banner", body)
				.then((response) => {
					commit("setStatusSubmit", true);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				}).finally(() => {
					dispatch('setLoadingGlobal', false, { root: true })
				})
		});
	},
	updateBanner({ commit, dispatch }, payload) {
		services.setHeader();
		dispatch('setLoadingGlobal', true, { root: true })
		return new Promise((resolve, reject) => {
			services
				.put("banner/" + payload.id, payload.body)
				.then((response) => {
					commit("setStatusSubmit", true);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				}).finally(() => {
					dispatch('setLoadingGlobal', false, { root: true })
				})
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
